<div id="reportListButtonWrap" *ngIf="reports">
    <div id="allReports" (click)="onClick()">所有报告</div>
    <div class="casePracticeBtn" *ngFor="let report of reports; index as i" (click)="switchReport(report.id, report.type, i)" [innerHTML]="report.nameHtml"></div>
</div>


// WEBPACK FOOTER //
// ./src/app/report-list-button/report-list-button.component.html